import { createSelector } from 'reselect'

export const getParentCategories = createSelector(
  (state) => state && state.categories && state.categories.parentCategories ? state.categories.parentCategories : [],
  (parentCategories) => parentCategories
)
